import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import DashboardApiService from './_services/dashboard.api.service';

import { MutationTypes, ActionTypes } from './store.types';

export { namespace } from './store.types';

export default {
  namespaced: true,
  state: {
    stats: {},
  },
  mutations: {
    [MutationTypes.SET_STATS](state, payload) {
      state.stats = payload;
    },
  },
  actions: {
    async [ActionTypes.GET_STATS](
      { commit, rootState: { [LocationsNamespace]: l } },
      { suffix = l.suffix, ...rest },
    ) {
      commit(MutationTypes.SET_STATS, await DashboardApiService.getStats({ suffix, ...rest }));
    },
  },
};
